/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type ListInboxThreadsChannel = typeof ListInboxThreadsChannel[keyof typeof ListInboxThreadsChannel];


export const ListInboxThreadsChannel = {
  email: 'email',
  linkedin: 'linkedin',
  all: 'all',
} as const;
